export default __webpack_public_path__ + "static/media/user.341b023d.svg";